import api from "../axios/index";

const getAccountId = () => {
  return sessionStorage.getItem("acc_id");
};

export const getChronicConditionOptions = async (location_id) => {
  const account_id = getAccountId();
  const response = await api.get(
    `/conditions/${account_id}/${location_id}/chronic-conditions/`
  );
  return response.data;
};

export const addChronicConditionOption = async (data, location_id) => {
  const account_id = getAccountId();
  const response = await api.post(
    `/conditions/${account_id}/${location_id}/chronic-conditions/`,
    data
  );
  return response.data;
};

export const editChronicConditionOption = async ({ id, data, location_id }) => {
  const account_id = getAccountId();
  const response = await api.put(
    `/conditions/${account_id}/${location_id}/chronic-conditions/${id}/`,
    data
  );
  return response.data;
};

export const deleteChronicConditionOption = async (id, location_id) => {
  const account_id = getAccountId();
  const response = await api.delete(
    `/conditions/${account_id}/${location_id}/chronic-conditions/${id}/`
  );
  return response.data;
};

// export const getDrNotesPatientCondition = async (location_id, patient_id) => {
//   const account_id = getAccountId();
//   const response = await api.get(
//     `/conditions/${account_id}/${location_id}/chronic-conditions/?patient_id=${patient_id}&dr_note=true`
//   );
//   return response.data;
// };

export const getDrNoteConditions = async (patient_id, location_id) => {
  const account_id = getAccountId();
  const response = await api.get(
    `/conditions/${account_id}/${location_id}/patient-conditions/?patient_id=${patient_id}&from_doctor_note=true`
  );
  return response.data;
};

export const getPatientConditions = async (careplan_id, location_id) => {
  const account_id = getAccountId();
  const response = await api.get(
    `/conditions/${account_id}/${location_id}/patient-conditions/?care_plan_id=${careplan_id}`
  );
  return response.data;
};

export const addPatientConditions = async (location_id, data) => {
  const account_id = getAccountId();
  const response = await api.post(
    `/conditions/${account_id}/${location_id}/patient-conditions/`,data
  );
  return response.data;
};

export const deletePatientConditions = async (id, location_id) => {
  const account_id = getAccountId();
  const response = await api.delete(
    `/conditions/${account_id}/${location_id}/patient-conditions/${id}/`
  );
  return response.data;
};

export const editPatientConditions = async (id, data, location_id) => {
  const account_id = getAccountId();
  const response = await api.patch(
    `/conditions/${account_id}/${location_id}/patient-conditions/${id}/`,
    data
  );
  return response.data;
};
